
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/OccasionMessagePage/OccasionMessagePage",
      function () {
        return require("private-next-pages/events/OccasionMessagePage/OccasionMessagePage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/OccasionMessagePage/OccasionMessagePage"])
      });
    }
  